const placeholder = {
  text: {
    isNotNUll:'数据不能为空!',
    verifyValue:'请输入NFC卡号',
    port:'请输入端口号',
    ip:'请输入ip',
    agreementId:'请输入gps设备id',
    manuId:'请输入制造商id',
    default: "请输入",
    account: "请输入账号",
    phone: "请输入手机号",
    telPhone: "请输入固定电话！",
    name: "请输入名称",
    imei:"请输入imei号",
    groupName:"请输入群组名称",
    groupId:"请输入群组Id",
    domainName: "请输入域名",
    identification: "请输入合法身份证号码",
    companyName: "请输入公司名称",
    password: "请输入密码",
    eamil: "请输入邮箱",
    remark: "请输入备注",
    rangeSeparator:'-',
    startDate:'开始日期',
    endDate:'结束日期',
    iccid:'请输入iccid',
    begin:'请输入始数据',
    end:'请输入末数据',
    common:'请输入公共数据',
    flagData:'请输入标识数据',
    startData:'请输入起始iccid',
    endData:'请输入结束iccid',
    imeiCommon:'请输入9-12位公共数据',
    imeiStart:'请输入2-5位起始数据',
    imeiEnd:'请输入2-5位结束数据',
    startAccount:'请输入账号开始数据',

    year:"请选择年",
    season:"选择季度",
    orderId:'请输入订单Id',
    noDinding:"无绑定",
    talkie:"对讲",//对讲
    dispatch:"调度",//调度
    f2f:"1个群组的基础价格",
    record:"录音存储1个月",//录音存储1个月
    record1:"录音存储3个月",//录音存储3个月
    record2:"录音存储6个月",//录音存储6个月
    record3:"录音存储一年",//录音存储一年
    location:"定位存储7天",//定位存储7天
    location1:"定位存储1个月",//定位存储1个月
    location2:"定位存储3个月",//定位存储3个月
    location3:"定位存储6个月",//定位存储6个月
    location4:"定位存储一年",//定位存储一年
    broadcast:"广播",//广播

  },
  select: {
    default: "请选择",
    status: "请选择状态",
    proxy: "请选择代理",
    enterprise: "请选择企业",
    subagent: '请选择子代理',
    domainName: "请选择域名",
    permission: "请选择权限类型",
    groupType: "请选择群组类型",
    secondaryManagement: "请选择二级管理"

  }
};
export default placeholder;



// WEBPACK FOOTER //
// ./src/api/lang/modules/placeholder/placeholder_zh.js